import React, { useState, useEffect } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import '../../styles/core.scss';
import css from './index.scss';
import DropDownList from '../dropdown-list/index';

import { COUNTRY_CURRICULUM_ID, DEFAULT_DROPDOWN_ID } from '../../constants';

// Helpers
import { compareByLastName, curriculumTypeOptions } from '../../helpers/utils';

let id = 0;
function createRows(courseId, name, version, alias, countryCode, state, yearGroups) {
    id += 1;
    const grades = yearGroups ? yearGroups.join(', ') : '';
    return { id, courseId, name, version, alias, countryCode, state, grades };
}

const CustomTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        fontSize: 14,
        fontFamily: 'Poppins',
        paddingRight: '30px'
    },
    body: {
        fontSize: 14,
        fontFamily: 'Poppins',
        paddingRight: '30px'
    }
}))(TableCell);

function MasterCourseList(props) {
    const {
        courses,
        countries,
        curriculumType,
        selectedCountry,
        handleCountryOnChange,
        handleCurriculumTypeOnChange,
        subjects,
        selectedSubject,
        handleSubjectOnChange
    } = props;

    // Filtered states
    const [filterCourses, setFilterCourses] = useState([]);
    const [hasFiltered, setHasFiltered] = useState(false);
    const [isNameFilterAscending, setIsNameFilterAscending] = useState(true);

    useEffect(() => {
        const rows = courses.map(course => createRows(course.masterCourseId, course.courseName, course.version,
            course.alias, course.countryCode, course.state, course.yearGroups));
        setFilterCourses(rows);
    }, [courses]);

    // Sorting Handlers
    const sortingCourseCallback = () => {
        const filterByCourseName = filterCourses.sort((...arg) => (
            compareByLastName(...arg, isNameFilterAscending)
        ));
        setFilterCourses(filterByCourseName);
        setHasFiltered(prevState => !prevState);
        setIsNameFilterAscending(prevState => !prevState);
    };

    const allSubjects = 'All subjects';
    const usableSubjects = subjects.map((subject, index) => (
        {
            name: index,
            value: subject
        }
    ));
    usableSubjects.unshift({ name: -1, value: allSubjects });

    const isSelectedSubjectEmpty = () => (
        selectedSubject === '' || selectedSubject === allSubjects || selectedSubject === '-1'
    );

    return (
        <div className={css.courseListComponent}>
            <div className={css.countryFilterComponent}>
                <DropDownList
                    name="curriculumType"
                    onChange={handleCurriculumTypeOnChange}
                    options={curriculumTypeOptions}
                    placeholder="Curriculum type"
                    value={curriculumType} />

                <DropDownList
                    name="countries"
                    disabled={curriculumType !== COUNTRY_CURRICULUM_ID}
                    onChange={handleCountryOnChange}
                    options={countries}
                    placeholder="Select a country"
                    value={selectedCountry} />
                {' '}
                <DropDownList
                    name="subjects"
                    disabled={curriculumType === DEFAULT_DROPDOWN_ID || curriculumType === ''}
                    onChange={handleSubjectOnChange}
                    options={usableSubjects}
                    placeholder="Filter by subject"
                    value={selectedSubject} />
            </div>
            <div className={css.courseTableComponent}>
                <Paper className={css.root}>
                    <Table className={css.table}>
                        <colgroup>
                            <col width="50%" />
                            <col width="5%" />
                            <col width="15%" />
                            <col width="10%" />
                            <col width="10%" />
                            <col width="10%" />
                        </colgroup>
                        <TableHead>
                            <TableRow>
                                <CustomTableCell align="left">
                                    CourseName
                                    {
                                        <button
                                            className={css.button}
                                            onClick={sortingCourseCallback}
                                        >
                                            <span className={`${css.chevron} ${isNameFilterAscending ? '' : css.bottom}`} />
                                        </button>
                                    }
                                </CustomTableCell>
                                <CustomTableCell align="center">Version</CustomTableCell>
                                <CustomTableCell align="center">Subject</CustomTableCell>
                                <CustomTableCell align="center">Year Groups</CustomTableCell>
                                <CustomTableCell align="center">Country</CustomTableCell>
                                <CustomTableCell align="center">State</CustomTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filterCourses.map((row) => {
                                const filteredOut = !isSelectedSubjectEmpty() && selectedSubject !== row.alias ?
                                    'subject__line--filtered-out' : '';
                                return (
                                    <TableRow
                                        key={`${hasFiltered}-${row.id}`}
                                        className={`subject__line ${filteredOut}`}>
                                        <CustomTableCell align="left">{row.name}</CustomTableCell>
                                        <CustomTableCell align="center">{row.version}</CustomTableCell>
                                        <CustomTableCell align="center">{row.alias}</CustomTableCell>
                                        <CustomTableCell align="center">{row.grades}</CustomTableCell>
                                        <CustomTableCell align="center">{row.countryCode}</CustomTableCell>
                                        <CustomTableCell align="center">{row.state}</CustomTableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </Paper>
            </div>
        </div>
    );
}

MasterCourseList.propTypes = {
    courses: PropTypes.array,
    countries: PropTypes.array,
    selectedCountry: PropTypes.string,
    handleCountryOnChange: PropTypes.func,
    handleCurriculumTypeOnChange: PropTypes.func,
    subjects: PropTypes.array,
    selectedSubject: PropTypes.string,
    handleSubjectOnChange: PropTypes.func,
    curriculumType: PropTypes.string
};

export default styleable(css)(MasterCourseList);



// WEBPACK FOOTER //
// ./app/components/master-course-list/index.js